module.exports = __webpack_public_path__ + "static/media/coritiba.b0c8b176.svg";